import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Theme from '@dagensmat/carrot/Theme';
import { Typography } from '@dagensmat/carrot/Components';
import { Container } from '@dagensmat/carrot/Layout';
import Button from '_common/components/button/Button.style';
import Icon from '_common/components/utils/Icon';
import { DeliveryWindow } from '../../../types/Consumer';
import FormattedDeliveryInformation from './FormattedDeliveryInformation';

type IEditDeliveryInformationButton = {
  deliveryAddress?: string;
  deliveryInfo?: string;
  deliveryWindow?: DeliveryWindow;
  redirectTo?: string;
  showHeader?: boolean;
};

const EditDeliveryInformationRedirector = ({
  deliveryAddress,
  deliveryInfo,
  deliveryWindow,
  redirectTo = '/profile',
  showHeader = true
}: IEditDeliveryInformationButton) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <Container>
      {showHeader && (
        <Typography variant="secondaryHeading" mb="s">
          {t('common:DeliveryInformation')}
        </Typography>
      )}
      <FormattedDeliveryInformation
        deliveryAddress={deliveryAddress}
        deliveryWindow={deliveryWindow}
        deliveryInfo={deliveryInfo}
      />
      {!deliveryInfo && (
        <Typography color="secondary" variant="paragraphSmall">
          {t('consumer:AddSpecificDeliveryInstructionsIfNeeded')}
        </Typography>
      )}
      <Button
        variant="ghost"
        mt={Theme.Spacings.s}
        onClick={() => {
          navigate('/delivery-information', {
            state: { redirect: redirectTo }
          });
        }}
      >
        <Icon icon="editSmall" mr={Theme.Spacings.xs} />
        {t('consumer:EditDeliveryInfo')}
      </Button>
    </Container>
  );
};
export default EditDeliveryInformationRedirector;
